export default class AdresseEmployeur {
	raisonSociale: string;
	voie: string;
	codePostal: string;
	ville: string;
	telephone: string;
	email: string;

	constructor(
		raisonSociale = '',
		voie = '',
		codePostal = '',
		ville = '',
		telephone = '',
		email = ''
	) {
		this.raisonSociale = raisonSociale;
		this.voie = voie;
		this.codePostal = codePostal;
		this.ville = ville;
		this.telephone = telephone;
		this.email = email;
	}
}
